import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import { WORKFLOW_STEPS } from '../content/home';

export default function ClinicalWorkflow() {
  const { t, path } = useLocale();
  return (
    <Section aria-labelledby="clinical-workflow-title">
      <div className="container">
        <Heading id="clinical-workflow-title">{t('home.workflow.title')}</Heading>
        <Introduction>{t('home.workflow.answer')}</Introduction>
        <Steps>
          {WORKFLOW_STEPS.map(step => (
            <li key={step}>
              <Number aria-hidden="true">{step}</Number>
              <h3>{t(`home.workflow.${step}.title`)}</h3>
              <p>{t(`home.workflow.${step}.description`)}</p>
            </li>
          ))}
        </Steps>
        <GuideLink to={path('/how-to-use')}>{t('home.workflow.guide')}</GuideLink>
      </div>
    </Section>
  );
}

const Section = styled.section`
  padding: 70px 0;
  background: var(--light-gray);
  text-align: center;
`;
const Heading = styled.h2`
  color: var(--primary-dark);
  font-size: clamp(1.75rem, 3vw, 2.5rem);
  margin-bottom: 20px;
`;
const Introduction = styled.p`
  max-width: 780px;
  margin: 0 auto 36px;
  color: var(--secondary);
  font-size: 1.15rem;
  line-height: 1.7;
`;
const Steps = styled.ol`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;
  list-style: none;
  text-align: start;
  margin-bottom: 32px;

  li { background: var(--white); padding: 28px; border-radius: 12px; }
  h3 { color: var(--primary-dark); margin: 14px 0 10px; font-size: 1.2rem; }
  p { line-height: 1.7; }

  @media (max-width: 768px) { grid-template-columns: 1fr; }
`;
const Number = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--primary);
  color: white;
  font-weight: 700;
`;
const GuideLink = styled(Link)`
  display: inline-block;
  padding: 12px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 4px;
`;
